import { PAGES } from '../../../constants/pages';
import { generatePath } from 'react-router-dom';
import { TProposalReportingMode } from '../types';

export const getApplicationLink = (mode: TProposalReportingMode, id: number | string) => {
  return mode === 'pi' ? PAGES.GRANTS_APPLICATION : generatePath(PAGES.APPLICATION, { id: String(id) });
};
